export default __webpack_public_path__ + "static/media/cobertura-CAEC.1c02879c.svg";